import React, { useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { Box, Button } from '@mui/material';
import '../css/TeamTrackerPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faEye } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import BACKEND_BASE_URL from './../config';

function TeamTrackerPage() {
    const [teamLoading, setTeamLoading] = useState(false);
    const [teamData, setTeamData] = useState({});
    const [issueDataLoading, setIssueDataLoading] = useState(false);
    const [issueData, setIssueData] = useState([]);
    const [stageHeading, setStageHeading] = useState('');

    useEffect(() => {
        setTeamLoading(true);
        const fetchTeamData = async () => {
            try {
                const sprintData = localStorage.getItem('sprintData');
                const sprintDataParsed = sprintData ? JSON.parse(sprintData) : {};
                const sprint_id = typeof sprintDataParsed.sprint_id !== 'undefined' ? sprintDataParsed.sprint_id : '';
                const response = await fetch(`${BACKEND_BASE_URL}/board/users?sprintId=${sprint_id}`,
                    {
                        headers:
                        {
                            'ngrok-skip-browser-warning': 'true'
                        }
                    });
                const data = await response.json();
                if (data.success) {
                    setTeamLoading(false);
                    setTeamData(data.data);
                }
            } catch (error) {
                console.error('Error fetching stage data:', error);
            }
        };

        fetchTeamData();
    }, []);

    const handleTeam = async (user, name) => {
        setIssueDataLoading(true);
        setStageHeading(name);
        try {
            const sprintData = localStorage.getItem('sprintData');
            const sprintDataParsed = sprintData ? JSON.parse(sprintData) : {};
            const sprint_id = typeof sprintDataParsed.sprint_id !== 'undefined' ? sprintDataParsed.sprint_id : '';
            const response = await fetch(`${BACKEND_BASE_URL}/sprint/userTime?user=${user}&sprintId=${sprint_id}`, {
                headers: {
                    'ngrok-skip-browser-warning': 'true',
                },
            });
            const data = await response.json();
            if (data.success) {
                setIssueData(data.data);
            }
        } catch (error) {
            console.error('Fetch error:', error);
        } finally {
            setIssueDataLoading(false);
        }
    }

    const exportToCSV = (data, totalDuration, filename = 'export.csv') => {
        if (!data || data.length === 0) {
            alert('No data to export');
            return;
        }

        const headers = Object.keys(data[0]).filter(key => key !== 'miliseconds');
        const csvRows = [
            headers.join(','), // header row
            ...data.map(row =>
                headers.map(field => JSON.stringify(row[field], (_, v) => v ?? '')).join(',')
            ),
            '', // empty row
            `,Total Duration:,${totalDuration}` // total at the end
        ];

        const csvContent = csvRows.join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    };

    const columns = [
        {
            header: 'User Name',
            accessorKey: 'name',
            size: 300,
        },
        {
            header: 'Active Tickets',
            accessorKey: 'count',
            size: 50,
        },
        {
            header: 'View',
            accessorKey: 'view',
            enableSorting: false,
            enableColumnFilter: false,
            size: 20,
            Cell: ({ row }) => (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                        handleTeam(row.original.id, row.original.name);
                    }}
                    title="View Member"
                >
                    <FontAwesomeIcon icon={faEye} />
                </Button>
            ),
        },
    ];


    return (
        <div className="container py-4">
            <div className="d-flex align-items-center justify-content-between p-3 bg-white shadow-sm rounded border mb-4">
                <h4 className="mb-0 fw-bold">
                    <i className="bi bi-people-fill me-2"></i>
                    Team wise Time in JIRA Issues
                </h4>
            </div>

            {teamLoading ? (
                <div className="d-flex justify-content-center my-5">
                    <div className="p-4 bg-white rounded shadow-sm border text-center" style={{ minWidth: '300px' }}>
                        <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-primary mb-3" />
                        <h6 className="mb-0 text-muted">Loading Active Users...</h6>
                    </div>
                </div>
            ) : (
                <Box className="mb-4">
                    <Box mt={2} sx={{ maxHeight: 350, overflow: 'auto' }}>
                        <MaterialReactTable
                            columns={columns}
                            data={teamData?.users ?? []}
                            isLoading={!teamData}
                            enableDensityToggle={false}
                            enableGlobalFilterToggle={false}
                            enablePagination={false}
                            initialState={{
                                showGlobalFilter: true,
                                density: 'compact',
                            }}
                        />
                    </Box>
                </Box>
            )}

            {issueDataLoading ? (
                <div className="d-flex justify-content-center my-5">
                    <div className="p-4 bg-white rounded shadow-sm border text-center" style={{ minWidth: '300px' }}>
                        <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-primary mb-3" />
                        <h6 className="mb-0 text-muted">Processing your request...</h6>
                    </div>
                </div>
            ) : issueData?.issues?.length > 0 ? (
                <>
                    <div className="row">
                        <div className="col-sm-10">
                            <h5 className="mt-2 mb-2">{stageHeading}'s Work History</h5>
                        </div>
                        <div className="col-sm-2">
                              <button className="btn btn-success float-end" onClick={() => exportToCSV(issueData.issues, issueData.totalDuration, `${stageHeading}-sprint-history.csv`)}>Export CSV</button>
                        </div>
                    </div>
                    <ul className="list-group">
                        {issueData.issues.map((issue, index) => (
                            <li className="list-group-item-new">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <Link
                                            to={`/issue-tracker/${issue.key}`}
                                            style={{ textDecoration: 'none', color: '#007bff' }}
                                        >
                                            {issue.key}
                                        </Link>
                                    </div>
                                    <div className="col-sm-7">
                                        <p>{issue.summary}</p>
                                    </div>
                                    <div className="col-sm-2">
                                        <strong>Duration:</strong> {issue.duration}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </>
            ) : (
                <p className="text-center text-muted">No issues to display. Click a User to load data.</p>
            )}
        </div>
    );
}

export default TeamTrackerPage;